import React, { useEffect, useRef, useState } from "react";
import FileItem from "../../FileItem";
import FileuploadModal from "../../../Common/Modal/FileuploaderModal/FileUploadModal";
import images from "../../../../Assets/images";
import { useApiCall } from "Hooks/useApiCall";
import { useDispatch } from "react-redux";
import { getLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";
import "./style.css";
import {
  deleteEquipmentUsageFile,
  getEquipmentUsageFiles,
} from "Network/Core/EquipmentMaster/equipmentUsage";
import FileUploadModal from "../../../Common/Modal/FileuploaderModal/FileUploadModal";
import { formateDateAsPerUserPreference } from "Library/Utils";
import OptionButton from "Components/UI/OptionButton";
import { useRolePermission } from "Hooks/useRolePermission";
export interface InfoItemProps {
  title: string;
  value: string | React.ReactNode;
}

interface SideWindowTopDataProps {
  items: InfoItemProps[];
  isOpen: boolean;
  onClose: () => void;
  handleclose: () => void;
}

interface EquipmentUsageFile {
  id: number;
  fileUrl: string;
  createdAt: string;
  modifiedAt: string;
  isActive: boolean;
  ref: string;
  fileObject: string;
  fileName: string;
  fileSize: number;
  equipmentUsage: number;
}

const InfoItem: React.FC<InfoItemProps> = ({ title, value }) => {
  return (
    <div
      className="small"
      style={{
        fontSize: "0.875rem",
        fontFamily: "'YourPrimaryFont', sans-serif",
      }}
    >
      <p
        style={{
          color: "#yourTextColor", // Replace with the actual color
          fontFamily: "'YourPrimaryFont', sans-serif", // Apply custom font
          fontWeight: "500", // Equivalent to font-medium
          lineHeight: "1.375", // Equivalent to leading-snug (approximate)
          letterSpacing: "-0.01562em", // Equivalent to tracking-tight (approximate)
          fontSize: "0.875rem", // Equivalent to text-small (adjust for your needs)
        }}
      >
        {title}
      </p>
      <p
        style={{
          color: "#yourTextBlack2", // Replace with your actual custom color
          fontFamily: "'YourPrimaryFont', sans-serif", // Apply your custom font
          fontWeight: 600, // Equivalent to font-semibold (600 is semi-bold)
          marginTop: "0.25rem", // Equivalent to mt-1 (0.25rem)
          lineHeight: "1.375", // Equivalent to leading-snug
          letterSpacing: "-0.01562em", // Equivalent to tracking-tight
          fontSize: "0.875rem", // Equivalent to text-small (0.875rem)
        }}
      >
        {value}
      </p>
    </div>
  );
};

const SideWindowTopData: React.FC<SideWindowTopDataProps> = ({
  items,
  isOpen,
  onClose,
  handleclose,
}) => {
  const { call } = useApiCall();
  const dispatch = useDispatch();
  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const [equipmentFiles, SetEquipmentFiles] = useState<EquipmentUsageFile[]>(
    []
  );
  const [currentEquipmentUsage, setCurrentEquipmentUsage] = useState<any>();
  const [isUploadModalShow, setIsUploadModalShow] = useState<boolean>(false);
  const [activeFileIndex, setActiveFileIndex] = useState<EquipmentUsageFile>();
  const [isFileMenuClicked, setIsFileMenuClicked] = useState<boolean>(false);

  const dateFormat = getLocalStorage(ls_vars.USER_PREFERENCES)?.dateFormat?.id;
  const timeFormat = getLocalStorage(ls_vars.USER_PREFERENCES)?.timeFormat
    ?.format;
  const refOutsideModel = useRef<HTMLDivElement>(null);
  const { checkPermission } = useRolePermission();
  const canViewEquipmentUsageAttachment = checkPermission(["equipment:usage:attachment:view"]);
  const canCreateEquipmentUsageAttachment = checkPermission(["equipment:usage:attachment:create"]);
  const canUpdateEquipmentUsageAttachment = checkPermission(["equipment:usage:attachment:update"]);
  const canDeleteEquipmentUsageAttachment = checkPermission(["equipment:usage:attachment:delete"]);
  const canDownloadEquipmentUsageAttachment = checkPermission(["equipment:usage:attachment:download"]);

  useEffect(() => {
    if (items && items[0] && items[0].value) {
      setCurrentEquipmentUsage(items[0].value as number);
      getAttachments(items[0].value as number);
    }
  }, []);  

  const handleUploadClick = (file?: EquipmentUsageFile) => {
    setActiveFileIndex(file);
    setIsUploadModalShow(true);
  };

  const getAttachments = (id: number) => {
    call(
      () => getEquipmentUsageFiles(id, region, project.ref),
      (res: any) => {
        SetEquipmentFiles(res);
      }
    );
  };

  const handleDeleteFile = (activeFileIndex: EquipmentUsageFile) => {
    if (activeFileIndex && currentEquipmentUsage) {
      call(
        () =>
          deleteEquipmentUsageFile(
            activeFileIndex.id,
            currentEquipmentUsage,
            region,
            project.ref
          ),
        (res: any) => {
          getAttachments(currentEquipmentUsage);
        }
      );
    }
  };

  const handleUploadModalClose = () => {
    setIsUploadModalShow(false);
    setActiveFileIndex(undefined);
    if (currentEquipmentUsage) {
      getAttachments(currentEquipmentUsage);
    }
  };

  const convertFileSize = (size: number) => {
    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;

    const formatSize = (value: number) => {
      // Show 2 decimal places for small numbers, 1 for larger numbers
      return value >= 10 ? value.toFixed(1) : value.toFixed(2);
    };

    if (size < KB) {
      return `${size} bytes`;
    } else if (size < MB) {
      return `${formatSize(size / KB)} KB`;
    } else if (size < GB) {
      return `${formatSize(size / MB)} MB`;
    } else {
      return `${formatSize(size / GB)} GB`;
    }
  };

  useEffect(() => {
    if (
      items &&
      items[0] &&
      items[0].value &&
      typeof items[0].value === "string"
    ) {
      setCurrentEquipmentUsage(parseInt(items[0].value));
      getAttachments(parseInt(items[0].value));
    }
  }, []);

  const handleCloseOnClickOutSide = (
    event: React.MouseEvent<HTMLDivElement>
  ) => {
    if (
      refOutsideModel.current &&
      !refOutsideModel.current.contains(event.target as Node)
    ) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {isUploadModalShow && currentEquipmentUsage && (
        <FileUploadModal
          equipment={currentEquipmentUsage}
          project={project.ref}
          region={region}
          type="attachment"
          editingFileId={activeFileIndex?.id}
          handleClose={() => {
            handleUploadModalClose();
          }}
        />
      )}
      {!isUploadModalShow && (
        <div
          className="right-sidebar-modal"
          onClick={handleCloseOnClickOutSide}
        >
          <button
            className="btn side-bar-modal-btn"
            data-toggle="modal"
            data-target="#myModal2"
          >
            <img src={images.backIcon} />
          </button>

          <div
            className="modal right fade show"
            style={{ display: "block" }}
            id="myModal2"
            role="dialog"
            aria-labelledby="myModalLabel2"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content" ref={refOutsideModel}>
                <div className="modal-header">
                  <button
                    className="btn side-bar-modal-btn border-0"
                    data-toggle="modal"
                    data-target="#myModal2"
                    onClick={handleclose}
                  >
                    <img src={images.backIcon} />
                  </button>
                </div>

                <div className="modal-body">
                  <div className="flex-grow-1 overflow-visible position-relative">
                    <div>
                      <div className="w-100 d-flex justify-content-between align-items-center ml-4">
                        <h1 className="fs-6 fw-semibold mb-4 px-4 py-2 text-subtitle">
                          Attachments
                        </h1>
                      </div>
                      <div
                        className="row mb-4 ml-4 px-4"
                        style={{
                          gap: "60px 64px",
                        }}
                      >
                        {items.map(
                          (item, index) =>
                            item.title !== "id" && (
                              <div
                                className={
                                  item.title === "Equipment Name"
                                    ? "col-7"
                                    : "col-3"
                                }
                                key={index}
                              >
                                <InfoItem
                                  title={item.title}
                                  value={
                                    item.title === "Equipment Name" ? (
                                      <span className="equipment-name">
                                        {item.value}
                                      </span>
                                    ) : (
                                      item.value
                                    )
                                  }
                                />
                              </div>
                            )
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-between align-items-center m-4">
                        <h2 className="h6 font-weight-bold text-dark">Files</h2>
                        {canCreateEquipmentUsageAttachment && (<button
                          className="btn btn-link  font-weight-bold border-0"
                          style={{ color: "#0B907B" }}
                          onClick={() => handleUploadClick()}
                        >
                          Upload new file
                        </button>)}
                      </div>
                      {equipmentFiles && currentEquipmentUsage ? (
                        <div className="mb-3 w-100">
                          {equipmentFiles.map((file, index) => (
                            <div
                              key={file.id}
                              className="position-relative mb-3"
                            >
                              <FileItem
                                fileId={file.id}
                                equipmentId={currentEquipmentUsage}
                                region={region}
                                fileName={file.fileName}
                                fileCategory={""}
                                fileDate={formateDateAsPerUserPreference(
                                  file.modifiedAt,
                                  dateFormat
                                )}
                                fileSize={convertFileSize(file.fileSize)}
                                project={project.ref}
                                onEditClick={() => {
                                  handleUploadClick(file);
                                }}
                                onDeleteClick={() => {
                                  handleDeleteFile(file);
                                }}
                                canEdit={canUpdateEquipmentUsageAttachment}
                                canDelete={canDeleteEquipmentUsageAttachment}
                                canDownload={canDownloadEquipmentUsageAttachment}
                                canView={canViewEquipmentUsageAttachment}
                              />
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="mb-3 w-100">
                          <div className="position-relative mb-3 text-center">
                            No files uploaded
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideWindowTopData;
